import type { RootState } from '@src/store/reduxstore';

// eslint-disable-next-line import/prefer-default-export
export const activeChatQuickMessagesSelector = (state: RootState) =>
  state.activeChatQuickMessages;
